//import node packages
import React, { Fragment, useCallback,useRef } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import { change } from 'redux-form'

//import utility functions & assets
import domain_sidebar_image from '../../../utilities/images/add-domain.svg'
import {
  ADD_DOMAIN_PAGE,
  EDIT_DOMAIN_PAGE,
  LOCALE_STRING_OPTIONS,
  LOCALE_LANG_OPTIONS,
  getSlugByName,
  isMobileViewport
} from '../../../utilities/function/common'

import {
  getCartToken
} from '../../../utilities/function/cartToken'

import {
  getDataFromURL,
  getPageByURL
} from '../../../utilities/function/urlparams'

import {
  getProductLabel,
  getAttributes,
  getPurchasedDomainPrice,
  getFilteredConfigurationList
} from '../../../utilities/function/configuration'

import {
  getCycle,
  getPriceByBillingCycleID
} from '../../../utilities/function/billingCycle'

import {
  deleteCartItem,
  deleteConfigurationByCID,
  deleteAllProductConfigRelatedToDomain
} from '../../../app/action'

import { SHARED_HOSTING_TYPE } from '../../../utilities/function/servicetype'
import { getIconSlugBasedOnServiceType } from '../../../utilities/function/manageServiceTypes'
import SelectButtonDomain from "../steps/selectbutton/domain";
import {onSale} from "../pricedomain";

//import shared components
import Ellipsis from "../ellipsis";


//input internals
const getInputName = (name,index) => {
  if (name && index>=0) {
    const slug = getSlugByName(name)
    return `domain_config[${index}][${slug}]`
  }
  return undefined
}
const getInputIndex = (domainname,SelectDomainConfigForm) =>{
  let selectedIndex = 0
  if(SelectDomainConfigForm && SelectDomainConfigForm.values && SelectDomainConfigForm.values){
    const {domain_config} = SelectDomainConfigForm.values
    if(domain_config && Array.isArray(domain_config) && domain_config.length > 0){
      domain_config.forEach((item,index)=>{
        if(item && item.domain && item.tld){
          const {domain,tld} = item
          if(domainname === domain+tld){
            selectedIndex =  index
          }
        }
      })
    }
  }
  return selectedIndex
}
const getNoDomainImageURL = () =>{
  let url = domain_sidebar_image
  if(window.app_config && window.app_config.no_domain_icon){
    url = window.app_config.no_domain_icon
  }
  return url
}

//main component
let DomainSidebar = (props) => {

  //define variables
  const {
    configurations,
    viewport,
    SelectDomainConfigForm
  } = useSelector(state => ({
    configurations: state.app.configurations,
    viewport: state.app.viewport,
    SelectDomainConfigForm: state.form.SelectDomainConfigForm
  }), shallowEqual)
  const dispatch = useDispatch()
  const { location, domainList, history } = props
  const {config} = getDataFromURL(location.search)
  const timeout = useRef(null)

  //define functions
  const onDeleteCallback = useCallback((cid) => {
    const { a, domain, query } = getDataFromURL(location.search)
    if (a === 'add' && domain && query) {
      const inputName = getInputName('Upsells',getInputIndex(cid,SelectDomainConfigForm))
      dispatch(change('SelectDomainConfigForm',inputName,null))
      deleteAllProductConfigRelatedToDomain(cid,configurations,dispatch)
      if(timeout.current){
        window.clearTimeout(timeout.current)
      }
      timeout.current = window.setTimeout(()=>{
        if(configurations[cid]){
          const currentConfigurations = localStorage.configurations? JSON.parse(localStorage.configurations): {}
          deleteConfigurationByCID(currentConfigurations, cid, dispatch)
        }
      },300)

    } else {
      if (a === 'confdomain') {
        const payload = {
          token: getCartToken(),
          uuid: cid
        }
        deleteCartItem(payload, dispatch, history,'?a=checkout')
      }
    }
  }, [configurations, dispatch, history, location,SelectDomainConfigForm])

  //render functions
  const renderDomainHeading = () => {
    const { a, domain, query } = getDataFromURL(location.search)
    if (domain && a === 'add' && query !== undefined) {
      if (!domainList || (Array.isArray(domainList) && domainList.length === 0)) {
        return (
          <>

            <div className={'of-sidebar-domain__heading'}>
              <img src={getNoDomainImageURL()} className={'of-sidebar-domain__heading-image'} alt={'Adding Domain'} />
              <div className={'clear'} />
              <div className={'desc'}> Start by adding a domain name by clicking the <strong className={'of-sidebar-domain__heading-service-type'}>{domain}</strong> button</div>
            </div>
          </>
        )
      }
    }
    return (<></>)
  }
  const renderDomainList = () => {
    const hostingList = getFilteredConfigurationList(SHARED_HOSTING_TYPE, configurations, false, true)
    if (domainList && domainList.length > 0) {
      const renderItem = () => {
        return domainList.map((item, index) => {
          const getDomainName = () => {
            const { domainSearchResult, uuid, order_type,name } = item
            const getDomainNameString = () => {
              if(uuid){
                return name
              }
              if(domainSearchResult && domainSearchResult.domain && domainSearchResult.tld){
                const {domain,tld} = domainSearchResult
                return domain + tld
              }
              return null
            }
            const isActive = () => {
              return getDomainNameString() && getDomainNameString().length > 32
            }
            const getFormat = () => {
              const first = getDomainNameString().substring(0,10)
              const last = getDomainNameString().substring(getDomainNameString().length - 10)
              return (
                  <div className={'of-sidebar-domain-item__domain-name'}>
                    <span className={'of-sidebar-domain-item__order-type'}>{order_type}</span> - <span
                      className={'of-sidebar-domain-item__name'}>{first+'...'+last}</span>
                  </div>
              )
            }
            if(getDomainNameString()){
              return (
                  <Ellipsis className={'of-sidebar-domain-item-ellipsis'} isActive={isActive()} tooltip={getDomainNameString()} format={getFormat()}>
                    <div className={'of-sidebar-domain-item__domain-name'}>
                      <span className={'of-sidebar-domain-item__order-type'}>{order_type}</span> - <span
                        className={'of-sidebar-domain-item__name'}>{getDomainNameString()}</span>
                    </div>
                  </Ellipsis>
              )
            }
            return (<></>)
          }
          const getDomainPrice = () => {
            const {order_type} = item
            const selectedPrice = getPurchasedDomainPrice(item)
            if (selectedPrice && selectedPrice.price && selectedPrice.name) {
              const {price,name,old_price} = selectedPrice
              if (price === "0.00") {
                return (
                    <div className={'of-sidebar-domain-item__price of-sidebar-domain-item__price--free status-font-1-100'}>Free</div>
                )
              }
              if (order_type === 'transfer') {
                return (
                    <div className={'of-sidebar-domain-item__price'}>${price}{getCycle(name)}</div>
                )
              }
              if(onSale(old_price)){
                return (
                    <div className={'of-sidebar-domain-item__price-onsale'}>
                      <div className={'of-sidebar-domain-item__price text-font-4-100 of-sidebar-domain-item__price--old-price'}>${old_price}{getCycle(name)}</div>
                      <div className={'of-sidebar-domain-item__price status-font-3-100 of-sidebar-domain-item__price--sale-price'}>${price}{getCycle(name)}</div>
                    </div>
                )
              }
              return (
                  <div className={'of-sidebar-domain-item__price'}>${price}{getCycle(name)}</div>
              )
            }
            return (<></>)
          }
          const deleteConfig = (e) => {
            e.preventDefault()
            const { domainSearchResult, uuid } = item
            if (uuid) {
              onDeleteCallback(uuid)
            } else {
              if (domainSearchResult && domainSearchResult.domain && domainSearchResult.tld) {
                const { domain, tld } = domainSearchResult
                onDeleteCallback(domain + tld)
              }
            }

          }
          const getHosting = () => {
            if (hostingList && hostingList.length) {
              const selectedHosting = hostingList.find(i => {
                const { domainSearchResult, uuid } = item
                let domainname = ''
                if (uuid) {
                  domainname = item.name
                } else {
                  if (domainSearchResult && domainSearchResult.domain && domainSearchResult.tld) {
                    const { domain, tld } = domainSearchResult
                    domainname = domain + tld
                  }
                }
                return domainname === i.name
              })
              if (selectedHosting && selectedHosting.selectedProduct && selectedHosting.selectedProduct.attributes && selectedHosting.name && selectedHosting.billing_cycle_id) {
                const renderIcon = () => {
                  if (getIconSlugBasedOnServiceType(selectedHosting)) {
                    return (<i className={`icon icon-of-${getIconSlugBasedOnServiceType(selectedHosting)}`}/>)
                  }
                  return <></>
                }
                const getProductName = ()=>{
                  const {name,service_type} = selectedHosting.selectedProduct.attributes
                  return getProductLabel(name,service_type)
                }
                const getDomainName = () =>{
                  return selectedHosting.name
                }
                const renderBillingCycle =  () => {
                  const {price} = selectedHosting.selectedProduct.attributes
                  if(price){
                    const selectedPrice = getPriceByBillingCycleID(price,selectedHosting.billing_cycle_id)
                    if(selectedPrice && selectedPrice.price && selectedPrice.name){
                      return (
                        <div className={'of-sidebar-domain-hosting-item__billing-cycle'}>
                          <div className={'of-sidebar-domain-hosting-item__label text-font-4-100'}>Billing Cycle</div>
                          <div className={'of-sidebar-domain-hosting-item__price'}>${selectedPrice.price}{getCycle(selectedPrice.name)}</div>
                        </div>
                      )
                    }
                  }
                  return (<></>)
                }
                return (
                  <div className={'of-sidebar-domain-hosting-item'}>
                    <div className={'of-sidebar-domain-hosting-item__top side-panel-background-2-100'}>
                      <div className={'of-sidebar-domain-hosting-item__icon primary-background-1-100'}>
                        {renderIcon()}
                      </div>
                      <div className={'of-sidebar-domain-hosting-item__details'}>
                        <div className={'of-sidebar-domain-hosting-item__heading'}>{getProductName()}</div>
                        <div className={'of-sidebar-domain-hosting-item__domain'}>{getDomainName()}</div>
                      </div>
                    </div>
                    <div className={'of-sidebar-domain-hosting-item__bottom side-panel-background-2-100'}>
                      {renderBillingCycle()}
                    </div>
                  </div>
                )
              }
            }
            return (<></>)
          }

          return (
            <Fragment key={index}>
              <div className={'of-sidebar-domain-item side-panel-background-2-100'}>
                {getDomainName()}
                {getDomainPrice()}
                <button onClick={deleteConfig} className={'of-sidebar-domain-item__remove status-background-2-100'}><i
                  className={'icon-of-x icon'}/></button>
              </div>
              {getHosting()}
            </Fragment>
          )
        })
      }
      const renderButton = () => {
        const pageType = getPageByURL(location.search)
        const renderAddDomainPageButton = () => {
          const getTotal = () => {
            let total = 0
            domainList.forEach(item => {
              if (item.billing_cycle_id && getAttributes(item.selectedProduct)) {
                const selectedPrice = getPurchasedDomainPrice(item)
                if (selectedPrice && selectedPrice.price && parseFloat(selectedPrice.price)) {
                  //adding domain price
                  total += parseFloat(selectedPrice.price)
                  //adding hosting price
                  if(item && item.domainSearchResult && item.domainSearchResult.domain && item.domainSearchResult.tld
                      && hostingList && hostingList.length > 0){
                    const {domain,tld} = item.domainSearchResult
                    const selectedDomainName = domain + tld
                    const selectedHosting = hostingList.find(i=>i.name===selectedDomainName)
                    if(selectedHosting && selectedHosting.selectedProduct  && selectedHosting.selectedProduct.attributes && selectedHosting.billing_cycle_id){
                      const {price} = selectedHosting.selectedProduct.attributes
                      const selectedPrice = getPriceByBillingCycleID(price,selectedHosting.billing_cycle_id)
                      total += parseFloat(selectedPrice.price)
                    }
                  }
                }
              }
            })
            return total
          }
          const total = getTotal()
          return (
              <div className='of-sidebar-total'>
                <div className='of-sidebar-total__details'>
                  <div className='of-sidebar-total__label'>Total Amount</div>
                  <div className='of-sidebar-total__amount'>${total.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}</div>
                </div>
                <SelectButtonDomain className={'of-select-domain__button of-sidebar-total__button'} isDarked={true}/>
                {renderEligibilityText()}
              </div>
          )
        }
        const renderDomainPageButton = () => {
          return (
              <div className='of-sidebar-total'>
                <SelectButtonDomain className={'of-select-domain__button of-sidebar-total__button'} isDarked={true}/>
              </div>
          )
        }
        switch (pageType){
          case ADD_DOMAIN_PAGE:
            return renderAddDomainPageButton()
          case EDIT_DOMAIN_PAGE:
            return renderDomainPageButton()
          default:
            return <></>
        }
      }
      const renderSubHeading = () => {
        if (domainList.length === 1) {
          return (<div className={'of-sidebar__heading text-font-5-100'}>{domainList.length} Domain Name</div>)
        } else {
          if (domainList.length > 1) {
            return (<div className={'of-sidebar__heading text-font-5-100'}>{domainList.length} Domain Names</div>)
          }
        }
      }
      return (
        <div className={'of-sidebar-domain__list-wrapper'}>
          {renderSubHeading()}
          <div className={'of-sidebar-domain__list'}>
            {renderItem()}
          </div>
          {renderButton()}
        </div>
      )
    }
    return (<></>)
  }
  const renderEligibilityText = () => {
    if(SelectDomainConfigForm && SelectDomainConfigForm.syncErrors && config){
      return (<div className={'of-sidebar-total__eligibility-text text-font-5-100'}>Please enter the eligibility details for your domain name/s before proceeding.</div>)
    }
    return (<></>)
  }

  if (!isMobileViewport(viewport)) {
    return (
      <aside className='of-sidebar of-sidebar-domain side-panel-background-1-100'>
        {renderDomainHeading()}
        {renderDomainList()}
      </aside>)
  }
  return (<></>)
}
DomainSidebar.propTypes = {
  location: PropTypes.any,
  history: PropTypes.any,
  domainList: PropTypes.array
}

DomainSidebar = withRouter(DomainSidebar)

export default DomainSidebar
